<template>
    <v-flex>
        <v-list three-line class="shop-cart-item-list">
            <v-list-tile v-for="item in items"
                         :key="item.item_id"
                         :class="[item.stock === 0 ? 'no-stock v-list__tile--link' : 'v-list__tile--link']">

                <v-list-tile-avatar v-if="displayEditQuantity && !displaySelect" style="border-radius: 0"
                                    @click="goToDetail(item.item_id)">
                    <v-img v-if="item.item_image && baseUrl" v-bind:src="baseUrl + item.item_image" aspect-ratio="1.48"
                           style="border-radius: 0">
                    </v-img>
                </v-list-tile-avatar>
                <v-list-tile-avatar v-else-if="!displaySelect" style="border-radius: 0">
                    <v-img v-if="item.item_image" v-bind:src="baseUrl + item.item_image" aspect-ratio="1.48"
                           style="border-radius: 0">
                    </v-img>
                </v-list-tile-avatar>
                <v-list-tile-avatar v-else-if="displaySelect" style="border-radius: 0">
                    <v-radio :value=item></v-radio>
                </v-list-tile-avatar>


                <v-list-tile-action v-if="!displayEditQuantity && !displaySelect">
                    <v-list-tile-title v-if="!displayEditQuantity" class="title text-xs-center shop-cart-item-quantity">
                        {{ item.quantity }}
                    </v-list-tile-title>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title v-if="displayEditQuantity" class="shop-cart-item-name"
                                       @click="goToDetail(item.item_id)">
                        {{ item.item_name }}
                    </v-list-tile-title>
                    <v-list-tile-title v-else class="shop-cart-item-name">
                        {{ item.item_name }}
                    </v-list-tile-title>

                    <v-list-tile-sub-title v-if="item.stock === 0">{{
                            $vuetify.t('$vuetify.shop.shop_item_nostock')
                        }}
                    </v-list-tile-sub-title>

                    <v-list-tile-sub-title v-else-if="item.menu_items && item.menu_items.length > 0">
                        {{ item.item_unit_price }}&nbsp;{{ currencySymbol }}:&nbsp;
                        <span v-for="(menuItem, posMenuItem) in item.menu_items" :key="posMenuItem">
                            {{ menuItem.item_name }} |
                        </span>
                    </v-list-tile-sub-title>

                    <v-list-tile-sub-title v-else-if="!displaySelect" class="shop-cart-item-price">
                        {{ item.item_unit_price }}&nbsp;{{ currencySymbol }}
                    </v-list-tile-sub-title>

                </v-list-tile-content>
                <v-list-tile-action
                        v-if="(displayEditQuantity || displayRemove) && item.menu_items && item.menu_items.length === 0"
                        class="subheading text-lowercase shop-cart-item-quantity-input">
                    <v-text-field v-if="displayEditQuantity"
                                  v-model=item.quantity
                                  regular
                                  mask="###"
                    ></v-text-field>
                </v-list-tile-action>

                <!--                <v-list-tile-action class="hidden-sm-and-down && !displaySelect">-->
                <!--                <v-list-tile-action class="[!displaySelect ? 'hidden-sm-and-down' : '']">-->
                <v-list-tile-action class="hidden-sm-and-down">
                    <v-list-tile-title v-if="!displaySelect" class="shop-cart-item-total text-xs-right">{{
                            (item.item_unit_price *
                                    item.quantity).toFixed(2)
                        }}&nbsp;{{ currencySymbol }}
                    </v-list-tile-title>
                    <v-list-tile-title v-else class="shop-cart-item-total text-xs-right">{{ item.item_unit_price }}&nbsp;{{
                            currencySymbol
                        }}
                    </v-list-tile-title>
                </v-list-tile-action>

                <v-list-tile-action v-if="displayRemove || item.stock === 0">
                    <v-icon @click="removeItem(item.item_id)" right small class="shop-cart-item-del">far fa-trash
                    </v-icon>
                </v-list-tile-action>
            </v-list-tile>
        </v-list>
    </v-flex>
</template>


<script>
import {mapGetters} from "vuex";

export default {
    name: "ItemsList",
    //Parent (PurchaseDetail.vue, OrderStepResume.vue and OrderStepCart.vue) to Child (ItemsList.vue) Communication
    //The "props" are the elements which enable moving data from a parent component to a child component
    //"Props" is short for “properties” and is referring to properties set from the parent component
    //Note that props are strictly for one way communication from the parent to the child,
    // and you do not want to try and change the value of a prop directly in the child component.
    // To change a parent's property, a computed property from the parent should be used.
    props: {
        items: Array,
        cartItemsNoStock: Boolean,
        displayEditQuantity: Boolean,
        displayRemove: Boolean,
        displaySelect: Boolean
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters({
            currencySymbol: 'configs/currencySymbol',
            baseUrl: 'configs/apiImgBaseUrl',
        }),
    },
    methods: {
        /**
         * Adding a new Item to the Shopping Cart, which is stored on the local storage
         * @param itemId
         * @deprecated
         */
        appendIconCallback(itemId) {
            this.$store.dispatch("shop/addToCart", itemId);
        },
        /**
         * A unit of the Item is removed from the Shopping Cart. If the final quantity of the Item is zero,
         * the entrance of the Item is completely removed from the Shopping Cart.
         * @param itemId
         * @deprecated
         */
        prependIconCallback(itemId) {
            this.$store.dispatch("shop/removeFromCart", itemId);
        },
        /**
         * This function is triggered when the user selects an Item to access its detail;
         * this works as a redirect to the Items's detail interface.
         * @param pk
         **/
        goToDetail: function (pk) {
            this.$router.push({
                name: 'shop-item-detail', params: {
                    id: pk
                }
            })
        },
        /**
         * The Item is excluded from the Shopping Cart
         * @param itemId
         */
        removeItem(itemId) {
            this.$store.dispatch("shop/deleteFromCart", {itemId,});
        }
    }
}
</script>

<style scoped>

</style>